import API_DOMAIN from "../api/apiDomain";

export const getHost = () => {
  if (window.location.hostname === 'localhost') {
    return 'https://enabled-raptor-crucial.ngrok-free.app';
  }
  return API_DOMAIN;
};
